//EMPLOYEE STATUSES
import {
    AdminUserRoles,
    EmploymentStatus,
    FetchState,
    PayrollStatus,
    WorkEngagementType,
    WorkLocationMode, WorkNoticePeriod, WorkProbationPeriod
} from "../app/interfaces";

// EMPLOYMENT STATUSES
export const EMPLOYMENT_STATUS_EOR_QUOTE_REQUESTED:EmploymentStatus  = 'eor_quote_requested';
export const EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED:EmploymentStatus = 'eor_quote_provided';
export const EMPLOYMENT_STATUS_EOR_QUOTE_APPROVED:EmploymentStatus = 'eor_quote_approved';
export const EMPLOYMENT_STATUS_PENDING_EMPLOYEE_SIGNATURE:EmploymentStatus = 'pending_employee_signature';
export const EMPLOYMENT_STATUS_IN_REGISTRATION:EmploymentStatus = 'in_registration';
export const EMPLOYMENT_STATUS_ACTIVE:EmploymentStatus = 'active';
export const EMPLOYMENT_STATUS_COMPLETED:EmploymentStatus = 'completed';
export const EMPLOYMENT_STATUS_DELETED:EmploymentStatus = 'deleted';
export const EMPLOYMENT_STATUS_PENDING:EmploymentStatus = 'pending';
export const EMPLOYMENT_STATUS_TERMINATION_REQUEST:EmploymentStatus = 'termination_requested';
export const EMPLOYMENT_STATUS_TERMINATED:EmploymentStatus = 'terminated';

export const EMPLOYMENT_STATUS_RESIGNATION_REQUESTED = 'resignation_requested'; // ❌ NOT USED ANYMORE
export const EMPLOYMENT_STATUS_RESIGNED = 'resigned'; // ❌ NOT USED ANYMORE

export const EMPLOYMENT_STATUS_PENDING_REGISTRATION_PAYMENT:EmploymentStatus = 'pending_registration_payment';

export const validEmploymentStatuses: EmploymentStatus[] = [
    EMPLOYMENT_STATUS_EOR_QUOTE_REQUESTED,
    EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED,
    EMPLOYMENT_STATUS_EOR_QUOTE_APPROVED,
    EMPLOYMENT_STATUS_PENDING_EMPLOYEE_SIGNATURE,
    EMPLOYMENT_STATUS_IN_REGISTRATION,
    EMPLOYMENT_STATUS_ACTIVE,
    EMPLOYMENT_STATUS_COMPLETED,
    EMPLOYMENT_STATUS_DELETED,
    EMPLOYMENT_STATUS_PENDING,
    EMPLOYMENT_STATUS_TERMINATION_REQUEST,
    EMPLOYMENT_STATUS_TERMINATED,
    EMPLOYMENT_STATUS_PENDING_REGISTRATION_PAYMENT
]

export const pendingRegistrationStatuses: EmploymentStatus[] = [
    EMPLOYMENT_STATUS_EOR_QUOTE_REQUESTED,
    EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED,
    EMPLOYMENT_STATUS_EOR_QUOTE_APPROVED,
    EMPLOYMENT_STATUS_IN_REGISTRATION,
    EMPLOYMENT_STATUS_PENDING_EMPLOYEE_SIGNATURE,
    EMPLOYMENT_STATUS_PENDING_REGISTRATION_PAYMENT
]

export const pendingRegistrationStatusesRequiringAction: EmploymentStatus[] = [
    EMPLOYMENT_STATUS_EOR_QUOTE_REQUESTED,
    EMPLOYMENT_STATUS_EOR_QUOTE_APPROVED,
    EMPLOYMENT_STATUS_IN_REGISTRATION,
]

export const employeesPendingActionsStatuses: EmploymentStatus[] = [
    EMPLOYMENT_STATUS_EOR_QUOTE_REQUESTED,
    EMPLOYMENT_STATUS_EOR_QUOTE_APPROVED,
    EMPLOYMENT_STATUS_IN_REGISTRATION,
    EMPLOYMENT_STATUS_TERMINATION_REQUEST,
]

export const registeredStatuses: EmploymentStatus[] = [
    EMPLOYMENT_STATUS_ACTIVE,
    EMPLOYMENT_STATUS_COMPLETED,
    EMPLOYMENT_STATUS_DELETED,
    EMPLOYMENT_STATUS_TERMINATION_REQUEST,
    EMPLOYMENT_STATUS_TERMINATED,
]

export const employmentStatusesPayrollActionsVisible:EmploymentStatus[] = [
    EMPLOYMENT_STATUS_ACTIVE,
    EMPLOYMENT_STATUS_TERMINATION_REQUEST,
];

//PAYROLL STATUSES
export const PAYROLL_STATUS_PENDING_BONUS:PayrollStatus = 'pending_bonus';
export const PAYROLL_STATUS_PREPARING:PayrollStatus = 'preparing';
export const PAYROLL_STATUS_BONUS_PROVIDED = 'bonus_provided';
export const PAYROLL_STATUS_PENDING_COMPANY_PAYMENT:PayrollStatus = 'pending_company_payment';
export const PAYROLL_STATUS_PENDING_EOR_PARTNER_PAYMENT:PayrollStatus = 'pending_eor_partner_payment';
export const PAYROLL_STATUS_EOR_PARTNER_PAID:PayrollStatus = 'eor_partner_paid';
export const PAYROLL_STATUS_PENDING_PAYSLIP:PayrollStatus = 'pending_payslip';
export const PAYROLL_STATUS_PAID:PayrollStatus = 'paid';

// Please keep this array always sorted based on the order steps happens
export const allPayrollStatus: PayrollStatus[] = [
    PAYROLL_STATUS_PENDING_BONUS,
    PAYROLL_STATUS_BONUS_PROVIDED,
    PAYROLL_STATUS_PREPARING,
    PAYROLL_STATUS_PENDING_COMPANY_PAYMENT,
    PAYROLL_STATUS_PENDING_EOR_PARTNER_PAYMENT,
    PAYROLL_STATUS_EOR_PARTNER_PAID,
    PAYROLL_STATUS_PENDING_PAYSLIP,
    PAYROLL_STATUS_PAID
]

export const pendingPayrollStatuses: PayrollStatus[] = [

    PAYROLL_STATUS_PREPARING,
    PAYROLL_STATUS_BONUS_PROVIDED,
    PAYROLL_STATUS_PENDING_EOR_PARTNER_PAYMENT,
    PAYROLL_STATUS_EOR_PARTNER_PAID,
    PAYROLL_STATUS_PENDING_PAYSLIP,
    PAYROLL_STATUS_PENDING_COMPANY_PAYMENT
]

export const notPaidPayrollStatuses: PayrollStatus[] = [
    PAYROLL_STATUS_PENDING_BONUS,
    PAYROLL_STATUS_PREPARING,
    PAYROLL_STATUS_BONUS_PROVIDED,
    PAYROLL_STATUS_PENDING_COMPANY_PAYMENT,
    PAYROLL_STATUS_PENDING_EOR_PARTNER_PAYMENT,
    PAYROLL_STATUS_EOR_PARTNER_PAID,
    PAYROLL_STATUS_PENDING_PAYSLIP,
];


//EMPLOYEE TYPES
export const EMPLOYEE_TYPE_CONTRACTOR = 'contractor'
export const EMPLOYEE_TYPE_EMPLOYEE = 'employee'

//FETCH STATUSES
export const FETCH_STATUS_IDLE: FetchState = 'idle'
export const FETCH_STATUS_SUCCEEDED: FetchState = 'succeeded'
export const FETCH_STATUS_LOADING: FetchState = 'loading'
export const FETCH_STATUS_FAILED: FetchState = 'failed'

//ENDPOINTS
export const API_END_POINT_ID = '/id'
export const API_END_POINT_DOCUMENTS = '/documents'
export const API_END_POINT_DOWNLOAD = '/download'
export const API_END_POINT_COMPANY = '/company'
export const API_END_POINT_EOR_PARTNER_INVOICE = '/eor_partner_invoice'
export const API_END_POINT_COMPANIO_WORK = '/companio_work'
export const API_END_POINT_MULTIPLE = '/multiple'
export const API_END_POINT_INTERNAL = '/internal'
export const API_END_POINT_EMPLOYEE = '/employee'
export const API_END_POINT_PAYROLL = '/payroll'
export const API_END_POINT_PAYROLLS = '/payrolls'
export const API_END_POINT_UPDATE = '/update'
export const API_END_POINT_ADD_EOR_INVOICE = '/add_eor_invoice'
export const API_END_POINT_SET_EMPLOYEE_PAID = '/set_employee_paid'
export const APÌ_END_POINT_SEND_QUOTE = '/send_quote'
export const API_END_POINT_APPROVE_SALARY = '/approve_salary_update'
export const API_ENDPOINT_REJECT_SALARY= '/reject_salary_update'
export const API_ENDPOINT_COMPLETE_REGISTRATION= '/complete_registration'
export const API_ENDPOINT_TERMINATE_CONTRACT = '/terminate_contract'
export const API_ENDPOINT_REQUESTER = '/requester'
export const API_ENDPOINT_EOR_PARTNER = '/eor_partner'
export const API_ENDPOINT_EOR_COMPANY = '/eor_company'
export const API_ENDPOINT_SALARY = '/salary';
export const API_ENDPOINT_MODIFY = '/modify';

// EOR Salary change statuses
export const EOR_SALARY_CHANGE_STATUS_REQUESTED = 'requested';
export const EOR_SALARY_CHANGE_STATUS_APPROVED = 'approved';

export const ADMIN_USER_ROLE_ADMIN: AdminUserRoles = 'admin';
export const ADMIN_USER_ROLE_HR:AdminUserRoles = 'human_resources';

export const validAdminUserRoles: AdminUserRoles[] = [
    ADMIN_USER_ROLE_ADMIN,
    ADMIN_USER_ROLE_HR
]

export const CONTRACT_TERMINATION_REQUESTER_COMPANY = 'company';
export const CONTRACT_TERMINATION_REQUESTER_EMPLOYEE = 'employee';

export const REMAINING_VACATION_OPTION_ENJOY = 'take_vacation';
export const REMAINING_VACATION_OPTION_MONEY = 'money_compensation';

// Work location modes constants
export const WORK_LOCATION_MODE_REMOTE: WorkLocationMode = 'remote';
export const WORK_LOCATION_MODE_HYBRID: WorkLocationMode = 'hybrid';
export const WORK_LOCATION_MODE_ON_SITE: WorkLocationMode = 'on_site';

// Work engagement types constants
export const WORK_ENGAGEMENT_TYPE_FULL_TIME: WorkEngagementType = 'full_time';
export const WORK_ENGAGEMENT_TYPE_PART_TIME: WorkEngagementType = 'part_time';

// Probation Periods in months constants
export const WORK_PROBATION_PERIOD_ONE_MONTH: WorkProbationPeriod = 1;
export const WORK_PROBATION_PERIOD_TWO_MONTHS: WorkProbationPeriod = 2;
export const WORK_PROBATION_PERIOD_THREE_MONTHS: WorkProbationPeriod = 3;
export const WORK_PROBATION_PERIOD_FOUR_MONTHS: WorkProbationPeriod = 4;
export const WORK_PROBATION_PERIOD_FIVE_MONTHS: WorkProbationPeriod = 5;
export const WORK_PROBATION_PERIOD_SIX_MONTHS: WorkProbationPeriod = 6;

// Notice Periods in months constants
export const WORK_NOTICE_PERIOD_ONE_MONTH: WorkNoticePeriod = 1;
export const WORK_NOTICE_PERIOD_TWO_MONTHS: WorkNoticePeriod = 2;
export const WORK_NOTICE_PERIOD_THREE_MONTHS: WorkNoticePeriod = 3;

export const downloadBase64File = (base64Data: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = base64Data;
    link.download = fileName;
    link.click();
};
